import React from 'react';
import { howItWorksSteps } from '../data/mock';
import { ArrowRight, Layers, CheckCircle } from 'lucide-react';

export const DefaultState = () => {
  return (
    <div className="h-full flex flex-col justify-center px-8 py-10">
      {/* Welcome Section */}
      <div className="text-center mb-10">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-emerald-50 rounded-full mb-5">
          <Layers className="h-3.5 w-3.5 text-emerald-600" />
          <span className="text-xs font-medium text-emerald-700">Welcome to EliteBGrowth</span>
        </div>
        
        <h2 className="text-2xl font-bold text-slate-800 mb-3">
          Let's Build Something<br />
          <span className="text-emerald-600">Great Together</span>
        </h2>
        
        <p className="text-sm text-slate-500 max-w-md mx-auto leading-relaxed">
          Select a package or individual services from the sidebar to get started. 
          We'll customize the form to gather exactly what we need for your project.
        </p>
      </div>

      {/* How It Works */}
      <div className="max-w-lg mx-auto w-full">
        <h3 className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-5 text-center">
          How It Works
        </h3>
        
        <div className="space-y-3">
          {howItWorksSteps.map((step, index) => (
            <div
              key={step.step}
              className="flex items-start gap-3 p-3 rounded-xl bg-white border border-slate-100 hover:border-slate-200 hover:shadow-sm transition-all duration-300"
            >
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center">
                <span className="text-emerald-700 font-bold text-xs">{step.step}</span>
              </div>
              <div className="flex-1">
                <h4 className="font-semibold text-sm text-slate-800 mb-0.5">{step.title}</h4>
                <p className="text-xs text-slate-500 leading-relaxed">{step.description}</p>
              </div>
              {index < howItWorksSteps.length - 1 && (
                <ArrowRight className="h-3.5 w-3.5 text-slate-300 flex-shrink-0 mt-2" />
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Trust Indicators */}
      <div className="mt-10 text-center">
        <div className="flex items-center justify-center gap-5 text-xs text-slate-400">
          <div className="flex items-center gap-1.5">
            <CheckCircle className="h-3.5 w-3.5 text-emerald-500" />
            <span>Free Consultation</span>
          </div>
          <div className="flex items-center gap-1.5">
            <CheckCircle className="h-3.5 w-3.5 text-emerald-500" />
            <span>24-48 Hour Response</span>
          </div>
          <div className="flex items-center gap-1.5">
            <CheckCircle className="h-3.5 w-3.5 text-emerald-500" />
            <span>No Obligation</span>
          </div>
        </div>
      </div>
    </div>
  );
};
